/* eslint-disable @typescript-eslint/no-explicit-any */

import { container } from '@shared/common/dependency-injection/domain/container';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { AuthenticationRequiredService } from '@shared/common/network/domain/service/authentication-required.service';

export function dispatchAuthenticationRequiredOnApiError() {
  return (_target: any, _propertyKey: string, descriptor: PropertyDescriptor): void => {
    const wrappedFunction = descriptor.value;
    descriptor.value = async function (...args: any[]) {
      try {
        const result = wrappedFunction.apply(this, args);
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          return await result;
        }

        return result;
      } catch (error: unknown) {
        const authenticationRequiredService = container.get<AuthenticationRequiredService>(
          NetworkDependencyTypes.AuthenticationRequiredService,
        );
        authenticationRequiredService.dispatchAuthenticationRequired(error);

        throw error;
      }
    };
  };
}
